/**
 * Exceldownload working with NSWOW2 Tables
 */
class XTableNamer {
  constructor() {

    const elements = Array.prototype.slice.call(document.querySelectorAll('.content .ns-table-wrap, .content .ns-title-h4-tables, .content .ns-title-h1, .content .ns-title-h2, .content .accordion__title'));

    let h1;
    let h2;
    let h4;
    let c;
    const pageTitle = document.querySelector('.header__top-title');

    elements.forEach(element => {
      const className = element.classList[0];


      switch(className) {
        case "ns-title-h1":
          const span = element.querySelector('.ns-title-h1 > span:last-child:not(.ns-title-h1__audited)');
          if(!!span){
            h1 = span.innerText;
          }
          c = 0;
          break;
        case "ns-title-h2":
          if(!!element.innerText.trim()){
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "ns-title-h4-tables":
          if(!!element.innerText.trim()){
            h4 = element.innerText;
            c = 0;
          }
          break;
        case "accordion__title":
          const spanL = element.querySelector('span:last-child');
          if(!!spanL && !!spanL.innerText.trim()){
            h2 = spanL.innerText;
            c = 0;
          }
          break;
        case "ns-table-wrap":
          let title = '';
          let fileTitle = '';
          if(!!pageTitle){
            title += pageTitle.innerText;
          }
          if(!!h1){
            if(!!pageTitle){
              title += ' – ';
            }
            title += h1.trim();
          }
          if(!!h2){
            if(!!h1 || !!pageTitle){
              title += ' – ';
            }
            title += h2.trim();
            fileTitle += h2.trim().replace(/\s/g, '_');
          } else{
            fileTitle += h1.trim().replace(/\s/g, '_');
          }
          if(!!h4){
            title = pageTitle.innerText + ' – ' + h4.trim();
            fileTitle = h4.trim().replace(/\s/g, '_');
          }
          if(c > 0){
            title += ' ' + (c + 1);
            fileTitle += '_'+(c + 1);
          }
          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          c++;
          break;
      }
      // ifelement.
    });
  }
}
export default XTableNamer;
